export const STORAGE_KEY = 'dcc.chatbot.history'
const OPENED_STATUS_KEY = 'dcc.chatbot.isOpened'

const DEFAULT_HISTORY_MAX_MESSAGES = 20

export const HISTORY_MAX_MESSAGES =
    typeof window !== 'undefined' &&
    Number.isFinite(window.chatbotHistoryMaxMessages) &&
    window.chatbotHistoryMaxMessages > 0
        ? window.chatbotHistoryMaxMessages
        : DEFAULT_HISTORY_MAX_MESSAGES

export const ROLE_USER = 'user'
export const ROLE_ASSISTANT = 'assistant'

export const DENIAL_ROLE = 'denied'

export function loadHistory() {
    try {
        const raw = localStorage.getItem(STORAGE_KEY)
        if (!raw) return []
        const parsed = JSON.parse(raw)
        return Array.isArray(parsed) ? parsed : []
    } catch (e) {
        return []
    }
}

export function saveHistory(messages) {
    const trimmed = trim(messages)
    try {
        localStorage.setItem(STORAGE_KEY, JSON.stringify(trimmed))
    } catch (e) {
        return trimmed
    }
    return trimmed
}

export function saveOpenedStatus(status) {
    try {
        sessionStorage.setItem(OPENED_STATUS_KEY, status)
    } catch {
        // ignore
    }
}

export function getOpenedStatus() {
    try {
        const status = sessionStorage.getItem(OPENED_STATUS_KEY)
        return status === true || status === 'true'
    } catch {
        return false
    }
}

export function appendMessage(existing, role, text, signature) {
    const message = { role, text }
    if (signature) message.signature = signature
    return trim([...(existing || []), message])
}

export function clearHistory() {
    try {
        localStorage.removeItem(STORAGE_KEY)
    } catch (e) {
        return
    }
}

export function clearChatbotState() {
    clearHistory()
    try {
        sessionStorage.removeItem(OPENED_STATUS_KEY)
    } catch (e) {
        return
    }
}

function trim(messages) {
    if (!Array.isArray(messages)) return []
    if (messages.length <= HISTORY_MAX_MESSAGES) return messages
    return messages.slice(messages.length - HISTORY_MAX_MESSAGES)
}
